/** Come la lista admin delle aziende tratta quelle create e gestite dai partner. */
export const MANAGED_TENANTS_FILTERS = ['exclude', 'include', 'only'] as const;

export type ManagedTenantsFilter = (typeof MANAGED_TENANTS_FILTERS)[number];

/** Default dell'API quando `managed` manca: ogni chiamante storico continua a vedere tutte le aziende. */
export const DEFAULT_MANAGED_TENANTS_FILTER: ManagedTenantsFilter = 'include';

/** Default della pagina /admin/tenants: le aziende gestite dai partner restano nascoste. */
export const ADMIN_TENANTS_PAGE_MANAGED_FILTER: ManagedTenantsFilter = 'exclude';

export interface ManagedByPartnerInfo {
  consultantName: string;
  /** Studio partner del consulente gestore; null se non ne ha uno attivo. */
  partnerName: string | null;
}
